import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';

import messages from './Departments.intl';

import styles from './Departments.module.scss';

import OfficesStore from 'stores/Offices.store';

import { ANCHOR } from 'common/consts/common';
import { Container } from 'common/components/Layout/Layout';

import DepartmentsListWithoutMap from 'common/components/DepartmentsList/DepartmentsListWithoutMap';

import LanguageService from 'services/Language.service';

@injectIntl
@withRouter
@observer
export default class Departments extends Component {
  currentLanguage = LanguageService.getLang();

  componentDidMount() {
    OfficesStore.fetchOffices();
  }

  render() {
    const { polishOffices, abroadOffices, countCountries } = OfficesStore;

    return (
      <Container>
        <div className={styles.Header}>
          <h3 className={styles.HeaderTitle}>
            {this.props.intl.formatMessage(messages.title, {
              countryCount: countCountries
            })}
          </h3>
          {/*<Link to="/" className={styles.HeaderLink}>*/}
          {/*{this.props.intl.formatMessage(messages.showMap)}*/}
          {/*</Link>*/}
        </div>
        <DepartmentsListWithoutMap
          polishOffices={polishOffices}
          abroadOffices={abroadOffices}
          onClick={this.onDepartmentSet}
        />
      </Container>
    );
  }

  @Bind()
  onDepartmentSet(department) {
    this.props.history.push({
      pathname: ANCHOR.CONTACT[this.currentLanguage],
      state: {
        activeDepartmentID: department.id
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Departments/Departments.js